import { render, staticRenderFns } from "./AddNewCompanyComponent.vue?vue&type=template&id=12d25031&"
import script from "./AddNewCompanyComponent.vue?vue&type=script&lang=js&"
export * from "./AddNewCompanyComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports